import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomButton from '../../../../components/button';
import { IMAGES } from '../../../../../assets/images';


const SignUp = ({
    onPageUpdate,
    onFormSubmit,
    isLoader
}) => {
    const formik = useFormik({
        initialValues: {
            fullName: '',
            email: '',
            phoneNumber: '',
            password: '',
        },
        validationSchema: Yup.object({
            fullName: Yup.string()
                .required('Full Name is required'),
            email: Yup.string()
                .email('Invalid email address')
                .required('Email Address is required'),
            phoneNumber: Yup.string()
                .matches(/^\d+$/, 'Phone Number must be numeric')
                .required('Phone Number is required'),
            password: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Password is required'),
        }),
        onSubmit: (values) => {
            console.log('Form data:', values);
            onFormSubmit(values)
        },
    });
    return (

        <div>
            <div className='flex justify-center mb-5'>
                <img src={IMAGES.logo} alt="" className='w-[225px]' />
            </div>
            <h2 className="text-2xl font-bold mb-6 text-center">Create an Account</h2>
            <form onSubmit={formik.handleSubmit} className="space-y-4 w-[60%] mx-auto">
                {/* Full Name */}
                <div>
                    <label htmlFor="fullName" className="block text-sm font-medium text-gray-700">Full Name *</label>
                    <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.fullName && formik.errors.fullName ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.fullName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.fullName && formik.errors.fullName && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.fullName}</p>
                    )}
                </div>

                {/* Email Address */}
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address *</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.email && formik.errors.email ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.email}</p>
                    )}
                </div>

                {/* Phone Number */}
                <div>
                    <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">Phone Number *</label>
                    <input
                        type="text"
                        id="phoneNumber"
                        name="phoneNumber"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.phoneNumber && formik.errors.phoneNumber ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        maxLength="10"
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.phoneNumber}</p>
                    )}
                </div>

                {/* Password */}
                <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password *</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.password && formik.errors.password ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.password && formik.errors.password && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.password}</p>
                    )}
                </div>
                <CustomButton title={'Create Account'} type="submit" loader={isLoader} />
            </form>
            <p className="mt-4 text-center text-sm text-gray-600">
                Already have an account? <span onClick={() => onPageUpdate('signIn')} className="text-blue-500 hover:underline">Log In</span>
            </p>
        </div>
    )
}

export default SignUp